export const catalogMenu = [
  {
    path: "/catalog",
    name: "catalog.parent",
    icon: "book-open",
    meta: {
      title: "Catalog",
      parentMenu: true,
      ability: {
        action: "read",
        subject: ["Brand", "Products", "ProductCodes", "Enforcement"],
      },
    },
    children: [
      {
        path: "/channels",
        name: "channels",
        icon: "share-2",
        component: () => import("@/views/Channels/ChannelsList.vue"),
        meta: {
          title: "Channels",
          ability: { action: "read", subject: "Enforcement" },
        },
      },
      {
        path: "/brands",
        name: "brands",
        label: "Brands",
        icon: "bookmark",
        component: () => import("@/views/Brands/BrandsList.vue"),
        meta: {
          title: "Brands",
          ability: { action: "read", subject: "Brand" },
        },
      },
      {
        path: "/retailers",
        name: "retailers",
        label: "Retailers",
        icon: "shopping-bag",
        component: () => import("@/views/retailers/RetailersList.vue"),
        meta: {
          title: "Retailers",
          ability: { action: "read", subject: "Retailer" },
        },
      },
      {
        path: "/products-parent",
        name: "productParent",
        redirect: "/products",
        icon: "circle",
        meta: {
          title: "Products",
          parentMenu: true,
          ability: { action: "read", subject: "Products" },
        },
        children: [
          {
            path: "/products",
            name: "products",
            icon: "list",
            component: () => import("@/views/Products/ProductsList.vue"),
            meta: {
              title: "List",
              pageTitle: "Products List",
              ability: { action: "read", subject: "Products" },
            },
          },
          {
            path: "/products/transparency-codes",
            name: "products-transparency-codes",
            icon: "shield",
            component: () => import("@/views/Products/TransparencyCodes.vue"),
            meta: {
              title: "Transparency Codes",
              ability: { action: "read", subject: "ProductCodes" },
            },
          },
          {
            path: "/products/fbm-products",
            name: "fbm-products",
            icon: "shopping-cart",
            component: () => import("@/views/Products/FBMProducts.vue"),
            meta: {
              title: "FBM Products",
              ability: { action: "read", subject: "Products" },
            },
          },
        ],
      },
    ],
  },
];
